// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useMemo} from 'react';
import cn from 'classnames';
import {Link, useHistory} from 'react-router-dom';
import {i_card, i_cls_obj} from '../../../../hola/pub/ui/cards';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import Chevron_right from '../../../../hola/pub/img/hola2023/icons/16/chevron_right.svg';
import Chevron_down from '../../../../hola/pub/img/hola2023/icons/16/chevron_down.svg';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {use_region_countries} from './use_region_countries';
import {Menu_cards} from './menu_cards';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import styles from './nav_menu.module.less';
import {use_menu_config} from './nav_utils';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {use_debug_ui} from '../../../../hola/pub/lib/debug';

interface i_location_props {
    region: string;
    to: string;
}
const Location = (props: i_location_props)=>{
    const {region, to} = props;
    const {T} = use_translation_v({no_defaults: true});
    const {count, data, name} = use_region_countries(region, 5);
    const {width} = use_screen();
    const debug_nav_menu_cards = use_debug_ui('updated_nav_menu_cards');
    return <div className={styles.location}>
      <b className={styles.region}>
        <T>{name}</T>
        <Chevron_down className={styles.chevron}/>
      </b>{!debug_nav_menu_cards ? <br/> :
        width > 768 && width > 1279 && <br/>}
      <span>{count?.toLocaleString()} <T>proxies</T></span>
      <div className={styles.list_wrapper}>
        <div className={styles.list}>
          {data.map(c=>{
              return <Link className={styles.list_item} key={c.name} to={c.to}
                onClick={ev=>ev.stopPropagation()}>
                <span><T>{c.name}</T></span>
                <span>{c.count?.toLocaleString()} <T>proxies</T></span>
              </Link>;
          })}
          {to && <Link className={cn(styles.list_item,
            styles.see_all_link)} to={to}>
            <span><T>See all</T></span> <Chevron_right/>
          </Link>}
        </div>
      </div>
    </div>;
};


export const Locations_menu = ()=>{
    const {theme} = use_theme({def: 'toolip'});
    const menu = use_menu_config();
    const history = useHistory();
    const cards: i_card[] = useMemo(()=>{
        if (!menu?.locations)
            return [];
        return menu.locations.group_items.map(item=>({
            id: item.id,
            title: undefined,
            to: undefined,
            on_click: ()=>history.push(item.to),
            clickid: `nav_toolip_locations_${item.id}`,
            img: <img className={'lazyload'} alt={item.title}
              data-src={toolip_img_url(item.icon)}/>,
            text: <Location region={item.id} to={item.to}/>,
        }));
    }, []);
    const cls: i_cls_obj = {
        container: styles.cards,
        card: styles.card,
        title: cn(theme.monospace, styles.title),
        text: cn(theme.p3, theme.reg, styles.text),
        img: styles.flex_img,
    };
    return <Menu_cards cards={cards} cls={cls}/>;
};
